// material-ui
import Box from '@mui/material/Box';

// project imports
import IconButton from 'components/@extended/IconButton';

import useConfig from 'hooks/useConfig';
import { ThemeMode } from 'config';

// assets
import SunOutlined from '@ant-design/icons/SunOutlined';
import MoonOutlined from '@ant-design/icons/MoonOutlined';

// ==============================|| HEADER CONTENT - THEME MODE TOGGLE ||============================== //

export default function ThemeModeToggle() {
  const { mode, onChangeMode } = useConfig();

  const handleToggle = () => {
    onChangeMode(mode === ThemeMode.LIGHT ? ThemeMode.DARK : ThemeMode.LIGHT);
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 0.75 }}>
      <IconButton
        color="secondary"
        variant="light"
        sx={{
          color: 'text.primary'
        }}
        aria-label="toggle theme mode"
        onClick={handleToggle}
      >
        {mode === ThemeMode.LIGHT ? <MoonOutlined /> : <SunOutlined />}
      </IconButton>
    </Box>
  );
}
